import { useMutation } from '@tanstack/react-query';
import { ApiError, apiClient } from 'shared/api';

import { MemberSignUpReqDto, signupResponseType } from './authSchema';

const postSignup = async ({ body }: { body: MemberSignUpReqDto }): Promise<signupResponseType> => {
  const { data } = await apiClient.post('/auth/member/sign-up', { ...body });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

export const usePostSignup = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: signupResponseType) => void;
  onError: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: postSignup,

    onSuccess: (data) => {
      onSuccess(data);
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError && onError(error.message);
      }
    },
  });
};
